import { Typography, useMediaQuery, useTheme } from "@material-ui/core"
import { AddCircle } from "@material-ui/icons"
import React, { useContext, useEffect } from "react"
import AddedCourseCard from "~/components/Clients/AddedCourseCard"
import DarkButton from "~/components/Common/DarkButton"
import AppContext from "~/contexts/App"
import ClientContext from "~/contexts/Client"
import PermissionsWrapper from "~/components/Common/PermissionsWrapper"
import Box from "../../Common/Box"
import useStyles from "./styles"

const ClientCourses = () => {
  const classes = useStyles()
  const theme = useTheme()
  const { openDialog } = useContext(AppContext)
  const { client, courseArray, setCourseArray } = useContext(ClientContext)
  const smDown = useMediaQuery(theme.breakpoints.down("sm"))

  const openAddCourseDialog = () => {
    openDialog("addCourseToDialog")
  }

  useEffect(() => {
    if (client?.courses?.length > 0) {
      setCourseArray(client?.courses?.map((c) => c))
    }
  }, [])

  return (
    <>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        marginBottom="10px"
      >
        <Box display="flex" flexDirection="row" flexWrap="wrap">
          <Typography
            variant="h3"
            color="primary"
            style={{ fontWeight: "700", marginRight: "8px" }}
          >
            Courses
          </Typography>
        </Box>
        <PermissionsWrapper permissionGroup="admin">
          <DarkButton
            onClick={openAddCourseDialog}
            startIcon={
              <AddCircle
                fontSize="small"
                classes={{ root: classes.addCircle }}
              />
            }
          >
            New Course
          </DarkButton>
        </PermissionsWrapper>
      </Box>
      <Box
        marginBottom="10px"
        maxHeight={smDown ? "100%" : "400px"}
        overflow="auto"
      >
        {courseArray?.length > 0 &&
          courseArray.map((course) => (
            <AddedCourseCard course={course} key={course.id} type="view" />
          ))}
      </Box>
    </>
  )
}

ClientCourses.propTypes = {}
export default ClientCourses
